import { createFileRoute, notFound } from "@tanstack/react-router";
import { buildPageHead } from "@/lib/seo";
import BlogTopic from "@/pages/BlogTopic";

// Metrics scoped to one tag; the cross-type view lives at /hub/{tag}.
export const Route = createFileRoute("/metrics/topic/$tag")({
  // The library dataset is imported lazily so it stays out of the entry
  // bundle; only the small head fields are returned (they get serialized
  // into the SSR payload).
  loader: async ({ params }) => {
    const { getTag, getPostsByTag } = await import("@/data/library");
    const tag = getTag(params.tag);
    if (!tag) throw notFound();
    // No metrics carry this tag — 404 so thin pages never get indexed.
    const posts = getPostsByTag(tag.slug).filter((p) => p.href.startsWith("/metrics/"));
    if (posts.length === 0) throw notFound();
    return {
      title: `${tag.name} Metrics | Bigdelta`,
      description: tag.blurb,
      slug: tag.slug,
    };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    return buildPageHead({
      title: loaderData.title,
      description: loaderData.description,
      path: `/metrics/topic/${loaderData.slug}`,
    });
  },
  component: () => <BlogTopic scope="metrics" />,
});
